import { Link, useNavigate } from "react-router-dom";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import { useSelector } from "react-redux";
import methodModel from "../../methods/methods";
import { useEffect } from "react";

export default function Profile() {
  const history = useNavigate();
  const user = useSelector((state) => state.user);
  console.log(user, "user");

  useEffect(() => {
    if (!user?._id) {
      history("/login");
    }
  }, [user]);

  return (
    <>
      <Header />
      <div className="min-h-[calc(100vh_-_75px)] md:min-h-[calc(100vh_-_95px)] mt-[75px] lg:mt-[95px]">
        <div className="container mx-auto py-8 lg:py-14 px-5">
          <div className="flex justify-between items-center mb-10">
            <h2 className="text-2xl font-bold text-gray-800">Profile</h2>

            <Link to="/editprofile">
              <button className="flex gap-2 items-center justify-center bg-gradient-to-br from-[#115B9D] to-[#116DAE] text-white rounded-full text-sm hover:scale-[1.04] duration-300 transition px-5 py-2.5">
                Edit Profile
              </button>
            </Link>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 py-8 px-5 md:px-8 overflow-hidden text-center min-h-[308px] h-fit">
              <div className="h-16 bg-gradient-to-r from-[#115B9D] to-[#116DAE] rounded-xl mb-[-40px]"></div>
              <img
                src={methodModel.userImg(user?.image)}
                className="w-28 h-28 rounded-full mx-auto object-cover mb-4 border-4 border-white shadow-lg relative z-10 bg-white"
              />
              <h3 className="text-xl font-semibold text-gray-800 capitalize">
                {user?.fullName}
              </h3>
              <p className="text-gray-500 text-sm mb-3">{user?.email}</p>
              {/* <p className="text-gray-500 text-sm leading-relaxed">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard.
            </p> */}
            </div>
            <div className="lg:col-span-2 bg-white rounded-2xl shadow-md border border-gray-100 py-8 px-5 md:px-8">
              <h3 className="text-sm font-semibold text-[#115B9D] uppercase tracking-widest mb-5">
                Personal Information
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-sm text-gray-500 mb-1">Full Name</p>
                  <p className="text-gray-800 font-medium capitalize">
                    {user?.fullName}
                  </p>
                </div>
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-sm text-gray-500 mb-1">Email</p>
                  <p className="text-gray-800 font-medium">{user?.email}</p>
                </div>
                {/* <div className="bg-gray-50 rounded-xl p-4">
                <p className="text-sm text-gray-500 mb-1">Company</p>
                <p className="text-gray-800 font-medium capitalize">
                  {user?.companyName || "--"}
                </p>
              </div> */}
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-sm text-gray-500 mb-1">Mobile Number</p>
                  <p className="text-gray-800 font-medium">
                    {user?.mobileNo || "--"}
                  </p>
                </div>
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-sm text-gray-500 mb-1">Address</p>
                  <p className="text-gray-800 font-medium capitalize leading-relaxed">
                    {user?.address || "--"}
                  </p>
                </div>
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-sm text-gray-500 mb-1">State</p>
                  <p className="text-gray-800 font-medium capitalize leading-relaxed">
                    {user?.state || "--"}
                  </p>
                </div>
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-sm text-gray-500 mb-1">Country</p>
                  <p className="text-gray-800 font-medium capitalize leading-relaxed">
                    {user?.country || "--"}
                  </p>
                </div>
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-sm text-gray-500 mb-1">Pin Code</p>
                  <p className="text-gray-800 font-medium capitalize leading-relaxed">
                    {user?.pinCode || "--"}
                  </p>
                </div>
              </div>
              {/* <div className="mt-8 border-t pt-6">
              <h4 className="text-md font-semibold text-gray-800 mb-4">
                Account Details
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-sm text-gray-500 mb-1">Member Since</p>
                  <p className="text-gray-800 font-medium">Jan 2024</p>
                </div>
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-sm text-gray-500 mb-1">Status</p>
                  <p className="text-[#008236] font-medium">Active</p>
                </div>
              </div>
            </div> */}
            </div>
          </div>
        </div>
      </div>
      {methodModel.TokenChecker() && <Footer />}
    </>
  );
}
